import { RootState } from '../../RootState';
import selectSessionContent from './selectSessionContent';

const selectSessionUserId = (state: RootState): string => {
  const content = selectSessionContent(state);
  return content.guid;
};

export default selectSessionUserId;
